import React from 'react';
import MainLayout from '../components/MainLayout';

export default function WhatWeDo() {
  return (
    <>
    <MainLayout>

    <div className='container'>

        <div className='row'>
        <div className='col-12'>
        WhatWeDo
        </div>
        </div>

    </div>

    </MainLayout>
    </>
  )
}
